import React, { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { getProjects, createProject } from '../api';
import { useNavigate } from 'react-router-dom';

function ProjectList() {
  const { user, token } = useAuth();
  const [projects, setProjects] = useState([]);
  const [newProject, setNewProject] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    async function fetchProjects() {
      try {
        const data = await getProjects(token);
        setProjects(data.projects || []);
      } catch (err) {
        console.error(err);
      }
    }
    fetchProjects();
  }, [token]);

  const handleCreate = async () => {
    if (!newProject) return;
    await createProject(token, newProject);
    setProjects(prev => [...prev, newProject]);
    setNewProject('');
  };

  return (
    <div style={{ padding: '2rem' }}>
      <h1>{user.username}'s Projects</h1>
      <ul>
        {projects.map(p => (
          <li key={p} onClick={() => navigate(`/projects/${p}`)}>{p}</li>
        ))}
      </ul>
      <input value={newProject} onChange={e => setNewProject(e.target.value)} placeholder="New Project" />
      <button onClick={handleCreate}>Create Project</button>
    </div>
  );
}

export default ProjectList;

